import { Autocomplete, Box, InputLabel, useTheme } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { COUNTRIES } from "src/_mock";
import ChevronDown from "src/assets/icon/chevron/ChevronDown";
import MyErrorHelperText from "../denseForm/ErrorHelperText";
import { BootstrapInput } from "../form/TextField";

interface RHFCountrySelectProps {
  name: string;
  label?: string;
  disabled?: boolean;
  getFullValue?: boolean;
}

const RHFCountrySelect: React.FC<RHFCountrySelectProps> = (props) => {
  const { name, label, disabled, getFullValue } = props;
  const { control } = useFormContext();
  const theme = useTheme();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { value, onChange } = field;
        return (
          <Autocomplete
            id="country-select-demo"
            sx={{ width: "100%" }}
            value={
              value
                ? COUNTRIES.find(
                    (c) => c.code === (getFullValue ? value.code : value),
                  )
                : null
            }
            options={COUNTRIES}
            autoHighlight
            disabled={disabled}
            getOptionLabel={(option: any) => option.label}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            onChange={(_, data) => {
              onChange(data ? (getFullValue ? data : data.code) : null);
            }}
            popupIcon={
              <ChevronDown
                height={24}
                width={22}
                sx={{
                  p: "3px",
                  mr: `2px`,
                  color: "#657482",
                }}
              />
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 }, fontSize: "12px" }}
                {...props}
              >
                <img
                  loading="lazy"
                  width="20"
                  src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                  srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                  alt=""
                />
                {option.label} ({option.code})
              </Box>
            )}
            renderInput={({ ...params }) => {
              const { InputLabelProps, InputProps, inputProps, ...rest } =
                params;
              return (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                      alignItems: "flex-start",
                      p: 0,
                      gap: "4px",
                    }}
                  >
                    {label && (
                      <InputLabel
                        htmlFor={"country-select-demo"}
                        sx={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "#657482",
                        }}
                      >
                        {label}
                      </InputLabel>
                    )}
                    <BootstrapInput
                      endAdornment={InputProps?.endAdornment}
                      ref={InputProps?.ref}
                      {...params}
                      sx={{
                        "& .MuiInputBase-input": {
                          ...(!!fieldState.error && {
                            backgroundColor: theme.palette.error.light,
                            borderColor: theme.palette.error.dark,
                            color: theme.palette.error.dark,
                            "&::placeholder": {
                              opacity: 1,
                              color: theme.palette.error.dark,
                            },
                            "&:focus": {
                              borderColor: theme.palette.error.dark,
                              boxShadow: `0 0 0 0.01rem ${theme.palette.error.dark}`,
                            },
                          }),
                        },
                      }}
                    />
                    {
                      <MyErrorHelperText
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    }
                  </Box>
                </>
              );
            }}
          />
        );
      }}
    />
  );
};

export default RHFCountrySelect;
